import { useMemo, useState } from 'react'
import { useCart } from '@local/do-secundo-cart-provider'
import { bulkDeleteInvalidItemsInCart } from '../../../api/cart'
import { useFulfillment } from '../../FulfillmentProvider/FulfillmentProvider'
import { alertError } from '../../../auth/alertUtils'
import { useSentry } from 'banquet-runtime-modules'

interface UseBulkDeleteInvalidItemsProps {
  deleteInvalidPricingItems: () => void
  isLoading: boolean
}

export const useBulkDeleteInvalidItems = (): UseBulkDeleteInvalidItemsProps => {
  const { cartGuid, updateCartCache } = useCart()
  const { fastLinkName } = useFulfillment()
  const [isLoading, setIsLoading] = useState(false)
  const { captureException } = useSentry()

  const deleteInvalidPricingItems = useMemo(() => {
    return () => {
      setIsLoading(true)

      if (!cartGuid) {
        setIsLoading(false)
        return
      }

      bulkDeleteInvalidItemsInCart(cartGuid, fastLinkName)
        .then((cart) => {
          updateCartCache(cart)
        })
        .catch((error) => {
          alertError('Failed to remove items.')
          captureException(error)
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }, [cartGuid, fastLinkName, updateCartCache])

  return {
    deleteInvalidPricingItems,
    isLoading
  }
}
